document.addEventListener('DOMContentLoaded', function () {
  const acq = document.getElementById('acquisitionType');
  const inst = document.getElementById('installation');
  const mRate = document.getElementById('monthlyRate');
  const mLabel = document.querySelector('label[for="monthlyRate"]');
  const kWp = document.getElementById('kWp');
  const kLabel = document.querySelector('label[for="kWp"]');

  if (acq && inst) {
    acq.addEventListener('change', function () {
      if (this.value === 'financing') {
        mRate.style.display = 'block';
        mLabel.style.display = 'block';
      } else {
        mRate.style.display = 'none';
        mLabel.style.display = 'none';
      }
    });

    inst.addEventListener('change', function () {
      if (this.value === 'yes') {
        kWp.style.display = 'block';
        kLabel.style.display = 'block';
      } else {
        kWp.style.display = 'none';
        kLabel.style.display = 'none';
      }
    });

    acq.dispatchEvent(new Event('change'));
    inst.dispatchEvent(new Event('change'));
  }
});

function calculate() {
  const get = id => parseFloat(document.getElementById(id).value) || 0;
  const purchaseCosts = get('purchaseCosts');
  const monthlyRate = get('monthlyRate');
  const annualConsumption = get('annualConsumption');
  const currentElectricityPrice = get('currentElectricityPrice');
  const newElectricityPrice = get('newElectricityPrice');
  const selfConsumptionRate = get('selfConsumptionRate');
  const insuranceCosts = get('insuranceCosts');
  const installationSelected = document.getElementById('installation').value;
  const kWp = get('kWp');
  const feedInTariff = 0.0832;

  const installationCosts = installationSelected === 'yes' ? kWp * 230 : 0;
  const monthlySavings = -(currentElectricityPrice - newElectricityPrice);
  const annualFeedIn = annualConsumption * ((100 - selfConsumptionRate) / 100);
  const monthlyFeedIn = -1 * (annualFeedIn * feedInTariff / 12);
  const totalMonthlyCosts = insuranceCosts + monthlyRate + monthlySavings + monthlyFeedIn;

  document.getElementById('result').innerHTML = `
    <strong>Anschaffungskosten:</strong> ${purchaseCosts.toFixed(2)} € einmal<br>
    ${installationSelected === 'yes' ? `<strong>Lieferung u. Montage:</strong> ${installationCosts.toFixed(2)} € einmal<br>` : ''}
    <strong>Finanzierungsrate:</strong> ${monthlyRate.toFixed(2)} € mtl.<br>
    <strong>Versicherungskosten:</strong> ${insuranceCosts.toFixed(2)} € mtl.<br>
    <strong>Stromwechselersparnis:</strong> ${monthlySavings.toFixed(2)} € mtl.*<br>
    <strong>Vergütung Netzeinspeisung:</strong> ${monthlyFeedIn.toFixed(2)} € mtl.*<br>
    <strong>Gesamtkosten pro Monat:</strong> ${totalMonthlyCosts.toFixed(2)} €
  `;
}

function sendEmail() {
  const get = id => document.getElementById(id).value || 'Nicht angegeben';
  const result = document.getElementById('result').innerText;

  const emailBody = `*** PV-Projektkennzahlen ***

Projektname: ${get('customerName')}
Kontaktnummer: ${get('contactNumber')}

Art der Anschaffung: ${get('acquisitionType') === 'oneTime' ? 'Einmalige Anschaffung' : 'Finanzierung'}
Anschaffungskosten: ${get('purchaseCosts')} €
Monatliche Rate: ${get('monthlyRate')} €
Stromverbrauch: ${get('annualConsumption')} kWh
Strom alt: ${get('currentElectricityPrice')} €
Strom neu: ${get('newElectricityPrice')} €
Eigenverbrauch: ${get('selfConsumptionRate')} %
Versicherung: ${get('insuranceCosts')} €
Montage: ${get('installation') === 'yes' ? 'Ja' : 'Nein'}
KWp: ${get('kWp')}

--- Berechnung ---
${result}`;

  window.location.href = `mailto:anfrage@energy-thode.de?subject=Anfrage PV-Projekt Angebot&body=${encodeURIComponent(emailBody)}`;
}